export const SET_STATE = 'SET_GYM_STATE' // To make it easy, but this is a bad api
export const RESET = 'RESET_GYM_STATE'

export const ADD_MY_GYM = 'ADD_MY_GYM'
export const DELETE_MY_GYM = 'DELETE_MY_GYM'


export const ADD_GYM_MEMBER = 'ADD_GYM_MEMBER'
export const REMOVE_GYM_MEMBER = 'REMOVE_GYM_MEMBER'
export const LEAVE_GYM = 'LEAVE_GYM'


export const SET_SELECTABLE_MEMBERS = 'SET_SELECTABLE_MEMBERS'
export const SET_GYM_NAME = 'SET_GYM_NAME'
export const SET_GYM_MEMBERS = 'SET_GYM_MEMBERS' 
export const SET_MY_GYMS = 'SET_MY_GYMS'
export const SET_MEMBER_OF_GYMS = 'SET_MEMBER_OF_GYMS'
export const SET_OTHER_GYMS = 'SET_OTHER_GYMS'
export const SET_GYM_OCCUPATION = 'SET_GYM_OCCUPATION'


export const END_POINT = 'END_POINT_GYM'
export const REQUEST_JOIN_GYM = 'REQUEST_JOIN_GYM'
export const KICK_PARTICIPANT = 'KICK_PARTICIPANT'



